<template>
  <Tabs :selected="active_tab" @change="(val) => (active_tab = val)" centered>
    <v-tab class="activeTab" center ripple v-for="tab of tabs" :key="tab.id">
      {{ $t(tab.name) }}
    </v-tab>
    <v-tab-item>
      <Card flat class="sideCard px-1 py-2">
        <Card 
          class="pa-4 pl-5 mb-2" 
          v-for="(data, id) in pcsList" 
          :key="id"
          style="cursor: pointer"
          @click.native="selectPcs(data.id)"
        >
        <span :class="{ 'activeBlock': selected_pcs === data.id }">
          {{ data.name.toUpperCase() }} : 
          <span :class="getValueClass(data)">
            {{ data.actv_pwr_totl == null ? "N/A" : data.actv_pwr_totl }}
          </span> 
          <span :class="selected_pcs === data.id ? '' : 'white--text'">kW</span>
        </span>
        </Card>
      </Card>
    </v-tab-item>
  </Tabs>
</template>

<script>
import PcsServices from "@/services/Pcs";
import { mapGettersMixin } from "@/util/mixin/index";
import { mapGetters, mapMutations } from "vuex";
import _ from "lodash";

const moment = require("moment");

export default {
  mixins: [mapGettersMixin],
  data() {
    return {
      active_tab: 0,
      tabs: [{ id: 1, name: "PCS LIST" }],
      pcsList: {},
      selected_pcs: null,
      mqttCallback: null,
    };
  },
  computed: {
    ...mapGetters(["getSelectedPlantId"]),
  },
  async mounted() {
    this.$emit("loading", true);
    await this.fetchPcsLiveData();
    this.setupMqtt();
    this.$emit("loading", false);
  },
  beforeDestroy() {
    this.cleanupMqtt();
  },
  methods: {
    ...mapMutations(["SET_PROGRESS_BAR", "SET_LAST_CALL_TIME"]),
    getValueClass(data) {
      if (data.actv_pwr_totl == null) return "error--text";
      return this.selected_pcs === data.id ? "" : "number--text";
    },

    async fetchPcsLiveData() {
      const plantId = this.getSelectedPlantId;
      if (!plantId) return;

      this.SET_PROGRESS_BAR(true);
      try {
        const response = await PcsServices.fetchLiveActivePower(plantId);

        if (
          response &&
          response.data &&
          Array.isArray(response.data.message) &&
          response.data.message.length > 0
        ) {
          const message = response.data.message;
          const keyedData = _.keyBy(message, "id");
          
          this.pcsList = _.mapValues(keyedData, (item) => ({
            id: item.id,
            name: item.name,
            actv_pwr_totl: item.actv_pwr_totl,
          }));

          const formattedList = Object.values(this.pcsList).map(item => ({
            text: item.name,
            value: item.id
          }));
          this.$emit('pcsList', formattedList);

          if (formattedList.length > 0 && !this.selected_pcs) {
             this.selectPcs(formattedList[0].value);
          }

          this.$emit("pcs-live-data", message[0]);
        } else {
          console.warn("No PCS live data received for plant:", plantId);
          this.pcsList = {};
          this.$emit('pcsList', []);
        }
      } catch (error) {
        console.error("Error fetching PCS live data:", error);
      } finally {
        this.SET_PROGRESS_BAR(false);
      }
    },

    setupMqtt() {
      const plantId = this.getSelectedPlantId;
      if (!plantId) return;

      const topic = `live/${plantId}/pcs`;
      this.$mqtt.subscribe(topic);

      if (this.mqttCallback) {
        this.$mqtt.removeListener("message", this.mqttCallback);
      }

      this.mqttCallback = (receivedTopic, message) => {
        if (receivedTopic.endsWith("/pcs")) {
          try {
            const payload = JSON.parse(message.toString());
            const mqttData = payload.deviceList && payload.deviceList[0];

            if (mqttData && !mqttData.exception) {
              this.$emit("pcs-live-data", mqttData);

              const deviceId = mqttData.device_id;
              if (deviceId) {
                const existingDevice = this.pcsList[deviceId];
                
                if (existingDevice) {
                   if (existingDevice.actv_pwr_totl !== mqttData.actv_pwr_totl) {
                      this.$set(this.pcsList[deviceId], 'actv_pwr_totl', mqttData.actv_pwr_totl);
                   }
                } else {
                  this.$set(this.pcsList, deviceId, {
                    id: deviceId,
                    name: mqttData.name || `PCS ${deviceId}`,
                    actv_pwr_totl: mqttData.actv_pwr_totl,
                  });
                }
              }
            }
          } catch (e) {
            console.error("Error parsing PCS MQTT message:", e);
          }
        }
      };

      this.$mqtt.on("message", this.mqttCallback);
    },

    cleanupMqtt() {
      const plantId = this.getSelectedPlantId;
      if (plantId) {
        this.$mqtt.unsubscribe(`live/${plantId}/pcs`);
      }
      if (this.mqttCallback) {
        this.$mqtt.removeListener("message", this.mqttCallback);
        this.mqttCallback = null;
      }
    },

    callAllApi() {
      const updateTime = moment().format("MM-DD-YYYY H:mm:ss");
      this.SET_LAST_CALL_TIME(updateTime);
      this.fetchPcsLiveData();
    },
    selectPcs(id) {
      this.selected_pcs = id;
      this.$emit('activeBlock', id);
    },
  },
  watch: {
    isReload(val) {
      if (val) {
        this.setIntervalWithoutDelay(this.callAllApi);
      } else if (this.cacheInterval) {
        clearInterval(this.cacheInterval);
        this.cacheInterval = null;
      }
    },
    getSelectedPlantId(newVal, oldVal) {
      if (newVal && newVal !== oldVal) {
        this.cleanupMqtt();
        this.fetchPcsLiveData().then(() => {
          this.setupMqtt();
        });
      }
    },
  },
};
</script>

<style scoped>
.sideCard {
  height: 600px;
}

.activeTab:hover {
  background-color: var(--v-sixth-base);
}

.main-background {
  background-color: #2a335a;
}

.theme--dark {
  width: -webkit-fill-available;
}
@media only screen and (min-width: 768px) and (max-width: 992px) {
  .v-card {
    width: 200px !important;
  }
}
</style>
<style>
@media only screen and (min-width: 320px) and (max-width: 960px) {
  .v-select__selection--comma,
  .v-select .v-label {
    font-size: 13px !important;
  }

  .block-content {
    padding: 16px 10px;
  }

  .theme--dark .activeBlock,
  .block-content .v-list {
    border-radius: 10px !important;
  }

  .activeBlock {
    margin: 10px;
  }
}

.activeBlock {
  color: var(--v-accent-base) !important;
}
</style>
